import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { UIRouterModule } from '@uirouter/angular';

import { BoardRest } from './board.rest';
import { BoardService } from './board.service';
import { BoardResolvesService } from './board-resolves.service';
import { BoardListPagingComponent } from './boardList/boardListPaging/board.list.paging.component';
import { BoardAddEditModalComponent } from './boardAddEdit/board.add.edit.component';
import { BoardDeleteModalComponent } from './boardDelete/board.delete.component';
import { BoardListComponent } from './boardList/board.list.component';
import { BoardViewComponent } from './boardView/board.view.component';

import { CoreWidgetsModule } from '../../../widgets/core.widgets.module';
import { CoreServicesModule } from '../../core.services.module';
import { CoreFiltersModule } from '../../core.filters.module';
import { FormsModule } from '@angular/forms';

import { BOARD_STATES } from './board.routes.config';

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        CoreFiltersModule,
        CoreWidgetsModule,
        CoreServicesModule,
        UIRouterModule.forChild({
            states: BOARD_STATES
        })
    ],
    providers: [
        BoardRest,
        BoardService,
        BoardResolvesService
    ],
    declarations: [
        BoardListPagingComponent,
        BoardAddEditModalComponent,
        BoardDeleteModalComponent,
        BoardListComponent,
        BoardViewComponent,
    ],
})
export class BoardModule {
    constructor() { }
}